export default {
  applyTags: "Apply Tags...",
  parseProducts: "Batch pad add products...",
  getDataFile: "Download Latest Data",
  deleteDataFile: "Delete DataF ile...",
  emailDataFile: "Email Data File...",
  printDataFile: "Print Data File...",
  uploadToSupport: "Send to EMUN Support...",
  length: "Size",
  lastAccessTimeUtc: "Last Accessed",
  lastWriteTimeUtc: "Last Modified"
};
